export const OptionPills = ({ label, options, value, onChange, testId, error }) => (
  <div>
    <div className="flex items-center justify-between mb-2">
      <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-500">{label}</span>
      {error && (
        <span data-testid={`${testId}-error`} className="font-mono text-[11px] text-rose-400">
          Pick one
        </span>
      )}
    </div>
    <div role="radiogroup" aria-label={label} data-testid={testId} className="flex flex-wrap gap-2">
      {options.map((opt) => {
        const active = value === opt;
        return (
          <button
            key={opt}
            type="button"
            role="radio"
            aria-checked={active}
            data-testid={`${testId}-${opt.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "")}`}
            onClick={() => onChange(opt)}
            className={`px-3.5 py-2 rounded-full text-xs sm:text-sm font-medium border transition-all duration-300 ${
              active
                ? "bg-teal-500 text-[#121316] border-teal-500 shadow-[0_0_20px_rgba(20,184,166,0.3)]"
                : "bg-[#121316] text-zinc-400 border-zinc-800 hover:border-teal-500/50 hover:text-zinc-100"
            }`}
          >
            {opt}
          </button>
        );
      })}
    </div>
  </div>
);
